export const getValueOrFallback = (
  value?: string | number,
  fallback?: string,
): string | number => {
  return value || fallback || '-'
}

export const subtractVatFromPrice = (
  price: number,
  vatRatePercent = 22,
): number => {
  return Number((price / (1 + vatRatePercent / 100)).toFixed(2))
}

export const getSeasons = (): 'summer' | 'winter' => {
  const currentMonth = new Date().getMonth() + 1

  // Лето: с июня (6) по август (8)
  if (currentMonth >= 6 && currentMonth <= 8) {
    return 'summer'
  }

  // Зима: с декабря (12), января (1) и февраля (2)
  if (currentMonth === 12 || currentMonth <= 2) {
    return 'winter'
  }

  return 'winter'
}

export const numberToMoney = (value?: number): string =>
  value ? value.toFixed(0) : '0.00'
